const countryData = [
    {
      country: "Afghanistan",
      countryShort: "AF",
      countryCode: "ps",
      flagCode: "AF",
      currency: "AFN",
      currencySymbol: "؋",
      taxName: "BRT",
      taxPercentage: "10",
    },
    {
      country: "Albania",
      countryShort: "AL",
      countryCode: "sq",
      flagCode: "AL",
      currency: "ALL",
      currencySymbol: "L",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Algeria",
      countryShort: "DZ",
      countryCode: "ar",
      flagCode: "DZ",
      currency: "DZD",
      currencySymbol: "د.ج",
      taxName: "VAT",
      taxPercentage: "19",
    },
    {
      country: "Andorra",
      countryShort: "AD",
      countryCode: "ca",
      flagCode: "AD",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "IGI",
      taxPercentage: "4.5",
    },
    {
      country: "Angola",
      countryShort: "AO",
      countryCode: "pt",
      flagCode: "AO",
      currency: "AOA",
      currencySymbol: "Kz",
      taxName: "VAT",
      taxPercentage: "14",
    },
    {
      country: "Antigua and Barbuda",
      countryShort: "AG",
      countryCode: "en",
      flagCode: "AG",
      currency: "XCD",
      currencySymbol: "$",
      taxName: "ABST",
      taxPercentage: "15",
    },
    {
      country: "Argentina",
      countryShort: "AR",
      countryCode: "es",
      flagCode: "AR",
      currency: "ARS",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "21",
    },
    {
      country: "Armenia",
      countryShort: "AM",
      countryCode: "hy",
      flagCode: "AM",
      currency: "AMD",
      currencySymbol: "֏",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Australia",
      countryShort: "AU",
      countryCode: "en",
      flagCode: "AU",
      currency: "AUD",
      currencySymbol: "$",
      taxName: "GST",
      taxPercentage: "10",
    },
    {
      country: "Austria",
      countryShort: "AT",
      countryCode: "de",
      flagCode: "AT",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Azerbaijan",
      countryShort: "AZ",
      countryCode: "az",
      flagCode: "AZ",
      currency: "AZN",
      currencySymbol: "₼",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Bahamas",
      countryShort: "BS",
      countryCode: "en",
      flagCode: "BS",
      currency: "BSD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "12",
    },
    {
      country: "Bahrain",
      countryShort: "BH",
      countryCode: "ar",
      flagCode: "BH",
      currency: "BHD",
      currencySymbol: ".د.ب",
      taxName: "VAT",
      taxPercentage: "10",
    },
    {
      country: "Bangladesh",
      countryShort: "BD",
      countryCode: "bn",
      flagCode: "BD",
      currency: "BDT",
      currencySymbol: "৳",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Barbados",
      countryShort: "BB",
      countryCode: "en",
      flagCode: "BB",
      currency: "BBD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "17.5",
    },
    {
      country: "Belarus",
      countryShort: "BY",
      countryCode: "be",
      flagCode: "BY",
      currency: "BYN",
      currencySymbol: "Br",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Belgium",
      countryShort: "BE",
      countryCode: "nl",
      flagCode: "BE",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "21",
    },
    {
      country: "Belize",
      countryShort: "BZ",
      countryCode: "en",
      flagCode: "BZ",
      currency: "BZD",
      currencySymbol: "$",
      taxName: "GST",
      taxPercentage: "12.5",
    },
    {
      country: "Benin",
      countryShort: "BJ",
      countryCode: "fr",
      flagCode: "BJ",
      currency: "XOF",
      currencySymbol: "CFA",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Bhutan",
      countryShort: "BT",
      countryCode: "dz",
      flagCode: "BT",
      currency: "BTN",
      currencySymbol: "Nu.",
      taxName: "GST",
      taxPercentage: "7",
    },
    {
      country: "Bolivia",
      countryShort: "BO",
      countryCode: "es",
      flagCode: "BO",
      currency: "BOB",
      currencySymbol: "Bs.",
      taxName: "VAT",
      taxPercentage: "13",
    },
    {
      country: "Bosnia and Herzegovina",
      countryShort: "BA",
      countryCode: "bs",
      flagCode: "BA",
      currency: "BAM",
      currencySymbol: "KM",
      taxName: "VAT",
      taxPercentage: "17",
    },
    {
      country: "Botswana",
      countryShort: "BW",
      countryCode: "en",
      flagCode: "BW",
      currency: "BWP",
      currencySymbol: "P",
      taxName: "VAT",
      taxPercentage: "14",
    },
    {
      country: "Brazil",
      countryShort: "BR",
      countryCode: "pt",
      flagCode: "BR",
      currency: "BRL",
      currencySymbol: "R$",
      taxName: "ICMS",
      taxPercentage: "17",
    },
    {
      country: "Brunei",
      countryShort: "BN",
      countryCode: "ms",
      flagCode: "BN",
      currency: "BND",
      currencySymbol: "$",
      taxName: "No GST/VAT",
      taxPercentage: "0",
    },
    {
      country: "Bulgaria",
      countryShort: "BG",
      countryCode: "bg",
      flagCode: "BG",
      currency: "BGN",
      currencySymbol: "лв",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Burkina Faso",
      countryShort: "BF",
      countryCode: "fr",
      flagCode: "BF",
      currency: "XOF",
      currencySymbol: "CFA",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Burundi",
      countryShort: "BI",
      countryCode: "rn",
      flagCode: "BI",
      currency: "BIF",
      currencySymbol: "FBu",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Cambodia",
      countryShort: "KH",
      countryCode: "km",
      flagCode: "KH",
      currency: "KHR",
      currencySymbol: "៛",
      taxName: "VAT",
      taxPercentage: "10",
    },
    {
      country: "Cameroon",
      countryShort: "CM",
      countryCode: "fr",
      flagCode: "CM",
      currency: "XAF",
      currencySymbol: "FCFA",
      taxName: "VAT",
      taxPercentage: "19.25",
    },
    {
      country: "Canada",
      countryShort: "CA",
      countryCode: "en",
      flagCode: "CA",
      currency: "CAD",
      currencySymbol: "$",
      taxName: "GST/HST",
      taxPercentage: "5",
    },
    {
      country: "Cape Verde",
      countryShort: "CV",
      countryCode: "pt",
      flagCode: "CV",
      currency: "CVE",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Central African Republic",
      countryShort: "CF",
      countryCode: "fr",
      flagCode: "CF",
      currency: "XAF",
      currencySymbol: "FCFA",
      taxName: "VAT",
      taxPercentage: "19",
    },
    {
      country: "Chad",
      countryShort: "TD",
      countryCode: "fr",
      flagCode: "TD",
      currency: "XAF",
      currencySymbol: "FCFA",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Chile",
      countryShort: "CL",
      countryCode: "es",
      flagCode: "CL",
      currency: "CLP",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "19",
    },
    {
      country: "China",
      countryShort: "CN",
      countryCode: "zh",
      flagCode: "CN",
      currency: "CNY",
      currencySymbol: "¥",
      taxName: "VAT",
      taxPercentage: "13",
    },
    {
      country: "Colombia",
      countryShort: "CO",
      countryCode: "es",
      flagCode: "CO",
      currency: "COP",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "19",
    },
    {
      country: "Comoros",
      countryShort: "KM",
      countryCode: "ar",
      flagCode: "KM",
      currency: "KMF",
      currencySymbol: "CF",
      taxName: "Consumption Tax",
      taxPercentage: "10",
    },
    {
      country: "Congo (Brazzaville)",
      countryShort: "CG",
      countryCode: "fr",
      flagCode: "CG",
      currency: "XAF",
      currencySymbol: "FCFA",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Congo (Kinshasa)",
      countryShort: "CD",
      countryCode: "fr",
      flagCode: "CD",
      currency: "CDF",
      currencySymbol: "FC",
      taxName: "VAT",
      taxPercentage: "16",
    },
    {
      country: "Costa Rica",
      countryShort: "CR",
      countryCode: "es",
      flagCode: "CR",
      currency: "CRC",
      currencySymbol: "₡",
      taxName: "VAT",
      taxPercentage: "13",
    },
    {
      country: "Croatia",
      countryShort: "HR",
      countryCode: "hr",
      flagCode: "HR",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "25",
    },
    {
      country: "Cuba",
      countryShort: "CU",
      countryCode: "es",
      flagCode: "CU",
      currency: "CUP",
      currencySymbol: "$",
      taxName: "Sales Tax",
      taxPercentage: "10",
    },
    {
      country: "Cyprus",
      countryShort: "CY",
      countryCode: "el",
      flagCode: "CY",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "19",
    },
    {
      country: "Czech Republic",
      countryShort: "CZ",
      countryCode: "cs",
      flagCode: "CZ",
      currency: "CZK",
      currencySymbol: "Kč",
      taxName: "VAT",
      taxPercentage: "21",
    },
    {
      country: "Denmark",
      countryShort: "DK",
      countryCode: "da",
      flagCode: "DK",
      currency: "DKK",
      currencySymbol: "kr",
      taxName: "VAT",
      taxPercentage: "25",
    },
    {
      country: "Djibouti",
      countryShort: "DJ",
      countryCode: "fr",
      flagCode: "DJ",
      currency: "DJF",
      currencySymbol: "Fdj",
      taxName: "VAT",
      taxPercentage: "10",
    },
    {
      country: "Dominica",
      countryShort: "DM",
      countryCode: "en",
      flagCode: "DM",
      currency: "XCD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Dominican Republic",
      countryShort: "DO",
      countryCode: "es",
      flagCode: "DO",
      currency: "DOP",
      currencySymbol: "RD$",
      taxName: "ITBIS",
      taxPercentage: "18",
    },
    {
      country: "Ecuador",
      countryShort: "EC",
      countryCode: "es",
      flagCode: "EC",
      currency: "USD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "12",
    },
    {
      country: "Egypt",
      countryShort: "EG",
      countryCode: "ar",
      flagCode: "EG",
      currency: "EGP",
      currencySymbol: "£",
      taxName: "VAT",
      taxPercentage: "14",
    },
    {
      country: "El Salvador",
      countryShort: "SV",
      countryCode: "es",
      flagCode: "SV",
      currency: "USD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "13",
    },
    {
      country: "Equatorial Guinea",
      countryShort: "GQ",
      countryCode: "es",
      flagCode: "GQ",
      currency: "XAF",
      currencySymbol: "FCFA",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Eritrea",
      countryShort: "ER",
      countryCode: "ti",
      flagCode: "ER",
      currency: "ERN",
      currencySymbol: "Nfk",
      taxName: "Sales Tax",
      taxPercentage: "5",
    },
    {
      country: "Estonia",
      countryShort: "EE",
      countryCode: "et",
      flagCode: "EE",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Eswatini",
      countryShort: "SZ",
      countryCode: "en",
      flagCode: "SZ",
      currency: "SZL",
      currencySymbol: "L",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Ethiopia",
      countryShort: "ET",
      countryCode: "am",
      flagCode: "ET",
      currency: "ETB",
      currencySymbol: "Br",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Fiji",
      countryShort: "FJ",
      countryCode: "en",
      flagCode: "FJ",
      currency: "FJD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "9",
    },
    {
      country: "Finland",
      countryShort: "FI",
      countryCode: "fi",
      flagCode: "FI",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "24",
    },
    {
      country: "France",
      countryShort: "FR",
      countryCode: "fr",
      flagCode: "FR",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
      country: "Gabon",
      countryShort: "GA",
      countryCode: "fr",
      flagCode: "GA",
      currency: "XAF",
      currencySymbol: "FCFA",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Gambia",
      countryShort: "GM",
      countryCode: "en",
      flagCode: "GM",
      currency: "GMD",
      currencySymbol: "D",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Georgia",
      countryShort: "GE",
      countryCode: "ka",
      flagCode: "GE",
      currency: "GEL",
      currencySymbol: "₾",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Germany",
      countryShort: "DE",
      countryCode: "de",
      flagCode: "DE",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "19",
    },
    {
      country: "Ghana",
      countryShort: "GH",
      countryCode: "en",
      flagCode: "GH",
      currency: "GHS",
      currencySymbol: "₵",
      taxName: "VAT",
      taxPercentage: "12.5",
    },
    {
      country: "Greece",
      countryShort: "GR",
      countryCode: "el",
      flagCode: "GR",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "24",
    },
    {
      country: "Grenada",
      countryShort: "GD",
      countryCode: "en",
      flagCode: "GD",
      currency: "XCD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Guatemala",
      countryShort: "GT",
      countryCode: "es",
      flagCode: "GT",
      currency: "GTQ",
      currencySymbol: "Q",
      taxName: "VAT",
      taxPercentage: "12",
    },
    {
      country: "Guinea",
      countryShort: "GN",
      countryCode: "fr",
      flagCode: "GN",
      currency: "GNF",
      currencySymbol: "FG",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Guinea-Bissau",
      countryShort: "GW",
      countryCode: "pt",
      flagCode: "GW",
      currency: "XOF",
      currencySymbol: "CFA",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Guyana",
      countryShort: "GY",
      countryCode: "en",
      flagCode: "GY",
      currency: "GYD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "14",
    },
    {
      country: "Haiti",
      countryShort: "HT",
      countryCode: "fr",
      flagCode: "HT",
      currency: "HTG",
      currencySymbol: "G",
      taxName: "TCA",
      taxPercentage: "10",
    },
    {
      country: "Honduras",
      countryShort: "HN",
      countryCode: "es",
      flagCode: "HN",
      currency: "HNL",
      currencySymbol: "L",
      taxName: "Sales Tax",
      taxPercentage: "15",
    },
    {
      country: "Hungary",
      countryShort: "HU",
      countryCode: "hu",
      flagCode: "HU",
      currency: "HUF",
      currencySymbol: "Ft",
      taxName: "VAT",
      taxPercentage: "27",
    },
    {
      country: "Iceland",
      countryShort: "IS",
      countryCode: "is",
      flagCode: "IS",
      currency: "ISK",
      currencySymbol: "kr",
      taxName: "VAT",
      taxPercentage: "24",
    },
    {
      country: "India",
      countryShort: "IN",
      countryCode: "hi",
      flagCode: "IN",
      currency: "INR",
      currencySymbol: "₹",
      taxName: "GST",
      taxPercentage: "18",
    },
    {
      country: "Indonesia",
      countryShort: "ID",
      countryCode: "id",
      flagCode: "ID",
      currency: "IDR",
      currencySymbol: "Rp",
      taxName: "VAT",
      taxPercentage: "11",
    },
    {
      country: "Iran",
      countryShort: "IR",
      countryCode: "fa",
      flagCode: "IR",
      currency: "IRR",
      currencySymbol: "﷼",
      taxName: "VAT",
      taxPercentage: "9",
    },
    {
      country: "Iraq",
      countryShort: "IQ",
      countryCode: "ar",
      flagCode: "IQ",
      currency: "IQD",
      currencySymbol: "ع.د",
      taxName: "Sales Tax",
      taxPercentage: "5",
    },
    {
      country: "Ireland",
      countryShort: "IE",
      countryCode: "ga",
      flagCode: "IE",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "23",
    },
    {
      country: "Israel",
      countryShort: "IL",
      countryCode: "he",
      flagCode: "IL",
      currency: "ILS",
      currencySymbol: "₪",
      taxName: "VAT",
      taxPercentage: "17",
    },
    {
      country: "Italy",
      countryShort: "IT",
      countryCode: "it",
      flagCode: "IT",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "22",
    },
    {
      country: "Jamaica",
      countryShort: "JM",
      countryCode: "en",
      flagCode: "JM",
      currency: "JMD",
      currencySymbol: "$",
      taxName: "GCT",
      taxPercentage: "15",
    },
    {
      country: "Japan",
      countryShort: "JP",
      countryCode: "ja",
      flagCode: "JP",
      currency: "JPY",
      currencySymbol: "¥",
      taxName: "Consumption Tax",
      taxPercentage: "10",
    },
    {
      country: "Jordan",
      countryShort: "JO",
      countryCode: "ar",
      flagCode: "JO",
      currency: "JOD",
      currencySymbol: "د.ا",
      taxName: "GST",
      taxPercentage: "16",
    },
    {
      country: "Kazakhstan",
      countryShort: "KZ",
      countryCode: "kk",
      flagCode: "KZ",
      currency: "KZT",
      currencySymbol: "₸",
      taxName: "VAT",
      taxPercentage: "12",
    },
    {
      country: "Kenya",
      countryShort: "KE",
      countryCode: "sw",
      flagCode: "KE",
      currency: "KES",
      currencySymbol: "KSh",
      taxName: "VAT",
      taxPercentage: "16",
    },
    {
      country: "Kiribati",
      countryShort: "KI",
      countryCode: "en",
      flagCode: "KI",
      currency: "AUD",
      currencySymbol: "$",
      taxName: "VAT",
      taxPercentage: "12.5",
    },
    {
      country: "Kosovo",
      countryShort: "XK",
      countryCode: "sq",
      flagCode: "XK",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "18",
    },
    {
      country: "Kuwait",
      countryShort: "KW",
      countryCode: "ar",
      flagCode: "KW",
      currency: "KWD",
      currencySymbol: "د.ك",
      taxName: "VAT",
      taxPercentage: "5",
    },
    {
      country: "Kyrgyzstan",
      countryShort: "KG",
      countryCode: "ky",
      flagCode: "KG",
      currency: "KGS",
      currencySymbol: "с",
      taxName: "VAT",
      taxPercentage: "12",
    },
    {
      country: "Laos",
      countryShort: "LA",
      countryCode: "lo",
      flagCode: "LA",
      currency: "LAK",
      currencySymbol: "₭",
      taxName: "VAT",
      taxPercentage: "10",
    },
    {
      country: "Latvia",
      countryShort: "LV",
      countryCode: "lv",
      flagCode: "LV",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "21",
    },
    {
      country: "Lebanon",
      countryShort: "LB",
      countryCode: "ar",
      flagCode: "LB",
      currency: "LBP",
      currencySymbol: "ل.ل",
      taxName: "VAT",
      taxPercentage: "11",
    },
    {
      country: "Lesotho",
      countryShort: "LS",
      countryCode: "st",
      flagCode: "LS",
      currency: "LSL",
      currencySymbol: "L",
      taxName: "VAT",
      taxPercentage: "15",
    },
    {
      country: "Liberia",
      countryShort: "LR",
      countryCode: "en",
      flagCode: "LR",
      currency: "LRD",
      currencySymbol: "$",
      taxName: "GST",
      taxPercentage: "10",
    },
    {
      country: "Libya",
      countryShort: "LY",
      countryCode: "ar",
      flagCode: "LY",
      currency: "LYD",
      currencySymbol: "ل.د",
      taxName: "Sales Tax",
      taxPercentage: "5",
    },
    {
      country: "Liechtenstein",
      countryShort: "LI",
      countryCode: "de",
      flagCode: "LI",
      currency: "CHF",
      currencySymbol: "CHF",
      taxName: "VAT",
      taxPercentage: "7.7",
    },
    {
      country: "Lithuania",
      countryShort: "LT",
      countryCode: "lt",
      flagCode: "LT",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "21",
    },
    {
      country: "Luxembourg",
      countryShort: "LU",
      countryCode: "lb",
      flagCode: "LU",
      currency: "EUR",
      currencySymbol: "€",
      taxName: "VAT",
      taxPercentage: "17",
    },
    {
      country: "Madagascar",
      countryShort: "MG",
      countryCode: "mg",
      flagCode: "MG",
      currency: "MGA",
      currencySymbol: "Ar",
      taxName: "VAT",
      taxPercentage: "20",
    },
    {
        country: "Madagascar",
        countryShort: "MG",
        countryCode: "mg",
        flagCode: "MG",
        currency: "MGA",
        currencySymbol: "Ar",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Malawi",
        countryShort: "MW",
        countryCode: "ny",
        flagCode: "MW",
        currency: "MWK",
        currencySymbol: "MK",
        taxName: "VAT",
        taxPercentage: "16.5",
      },
      {
        country: "Malaysia",
        countryShort: "MY",
        countryCode: "ms",
        flagCode: "MY",
        currency: "MYR",
        currencySymbol: "RM",
        taxName: "SST",
        taxPercentage: "6",
      },
      {
        country: "Maldives",
        countryShort: "MV",
        countryCode: "dv",
        flagCode: "MV",
        currency: "MVR",
        currencySymbol: "Rf",
        taxName: "GST",
        taxPercentage: "6",
      },
      {
        country: "Mali",
        countryShort: "ML",
        countryCode: "fr",
        flagCode: "ML",
        currency: "XOF",
        currencySymbol: "CFA",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Malta",
        countryShort: "MT",
        countryCode: "mt",
        flagCode: "MT",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Marshall Islands",
        countryShort: "MH",
        countryCode: "en",
        flagCode: "MH",
        currency: "USD",
        currencySymbol: "$",
        taxName: "Sales Tax",
        taxPercentage: "4",
      },
      {
        country: "Mauritania",
        countryShort: "MR",
        countryCode: "ar",
        flagCode: "MR",
        currency: "MRU",
        currencySymbol: "UM",
        taxName: "VAT",
        taxPercentage: "16",
      },
      {
        country: "Mauritius",
        countryShort: "MU",
        countryCode: "en",
        flagCode: "MU",
        currency: "MUR",
        currencySymbol: "₨",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Mexico",
        countryShort: "MX",
        countryCode: "es",
        flagCode: "MX",
        currency: "MXN",
        currencySymbol: "$",
        taxName: "IVA",
        taxPercentage: "16",
      },
      {
        country: "Micronesia",
        countryShort: "FM",
        countryCode: "en",
        flagCode: "FM",
        currency: "USD",
        currencySymbol: "$",
        taxName: "Sales Tax",
        taxPercentage: "5",
      },
      {
        country: "Moldova",
        countryShort: "MD",
        countryCode: "ro",
        flagCode: "MD",
        currency: "MDL",
        currencySymbol: "L",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Monaco",
        countryShort: "MC",
        countryCode: "fr",
        flagCode: "MC",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Mongolia",
        countryShort: "MN",
        countryCode: "mn",
        flagCode: "MN",
        currency: "MNT",
        currencySymbol: "₮",
        taxName: "VAT",
        taxPercentage: "10",
      },
      {
        country: "Montenegro",
        countryShort: "ME",
        countryCode: "sr",
        flagCode: "ME",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "21",
      },
      {
        country: "Morocco",
        countryShort: "MA",
        countryCode: "ar",
        flagCode: "MA",
        currency: "MAD",
        currencySymbol: "د.م.",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Mozambique",
        countryShort: "MZ",
        countryCode: "pt",
        flagCode: "MZ",
        currency: "MZN",
        currencySymbol: "MT",
        taxName: "VAT",
        taxPercentage: "17",
      },
      {
        country: "Myanmar",
        countryShort: "MM",
        countryCode: "my",
        flagCode: "MM",
        currency: "MMK",
        currencySymbol: "K",
        taxName: "Commercial Tax",
        taxPercentage: "5",
      },
      {
        country: "Namibia",
        countryShort: "NA",
        countryCode: "en",
        flagCode: "NA",
        currency: "NAD",
        currencySymbol: "$",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Nauru",
        countryShort: "NR",
        countryCode: "en",
        flagCode: "NR",
        currency: "AUD",
        currencySymbol: "$",
        taxName: "Business Tax",
        taxPercentage: "10",
      },
      {
        country: "Nepal",
        countryShort: "NP",
        countryCode: "ne",
        flagCode: "NP",
        currency: "NPR",
        currencySymbol: "₨",
        taxName: "VAT",
        taxPercentage: "13",
      },
      {
        country: "Netherlands",
        countryShort: "NL",
        countryCode: "nl",
        flagCode: "NL",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "21",
      },
      {
        country: "New Zealand",
        countryShort: "NZ",
        countryCode: "en",
        flagCode: "NZ",
        currency: "NZD",
        currencySymbol: "$",
        taxName: "GST",
        taxPercentage: "15",
      },
      {
        country: "Nicaragua",
        countryShort: "NI",
        countryCode: "es",
        flagCode: "NI",
        currency: "NIO",
        currencySymbol: "C$",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Niger",
        countryShort: "NE",
        countryCode: "fr",
        flagCode: "NE",
        currency: "XOF",
        currencySymbol: "CFA",
        taxName: "VAT",
        taxPercentage: "19",
      },
      {
        country: "Nigeria",
        countryShort: "NG",
        countryCode: "en",
        flagCode: "NG",
        currency: "NGN",
        currencySymbol: "₦",
        taxName: "VAT",
        taxPercentage: "7.5",
      },
      {
        country: "North Korea",
        countryShort: "KP",
        countryCode: "ko",
        flagCode: "KP",
        currency: "KPW",
        currencySymbol: "₩",
        taxName: "Turnover Tax",
        taxPercentage: "15",
      },
      {
        country: "North Macedonia",
        countryShort: "MK",
        countryCode: "mk",
        flagCode: "MK",
        currency: "MKD",
        currencySymbol: "ден",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Norway",
        countryShort: "NO",
        countryCode: "no",
        flagCode: "NO",
        currency: "NOK",
        currencySymbol: "kr",
        taxName: "VAT",
        taxPercentage: "25",
      },
      {
        country: "Oman",
        countryShort: "OM",
        countryCode: "ar",
        flagCode: "OM",
        currency: "OMR",
        currencySymbol: "ر.ع.",
        taxName: "VAT",
        taxPercentage: "5",
      },
      {
        country: "Pakistan",
        countryShort: "PK",
        countryCode: "ur",
        flagCode: "PK",
        currency: "PKR",
        currencySymbol: "₨",
        taxName: "GST",
        taxPercentage: "17",
      },
      {
        country: "Palau",
        countryShort: "PW",
        countryCode: "en",
        flagCode: "PW",
        currency: "USD",
        currencySymbol: "$",
        taxName: "Gross Receipts Tax",
        taxPercentage: "4",
      },
      {
        country: "Palestine",
        countryShort: "PS",
        countryCode: "ar",
        flagCode: "PS",
        currency: "ILS",
        currencySymbol: "₪",
        taxName: "VAT",
        taxPercentage: "16",
      },
      {
        country: "Panama",
        countryShort: "PA",
        countryCode: "es",
        flagCode: "PA",
        currency: "PAB",
        currencySymbol: "B/.",
        taxName: "ITBMS",
        taxPercentage: "7",
      },
      {
        country: "Papua New Guinea",
        countryShort: "PG",
        countryCode: "en",
        flagCode: "PG",
        currency: "PGK",
        currencySymbol: "K",
        taxName: "GST",
        taxPercentage: "10",
      },
      {
        country: "Paraguay",
        countryShort: "PY",
        countryCode: "es",
        flagCode: "PY",
        currency: "PYG",
        currencySymbol: "₲",
        taxName: "VAT",
        taxPercentage: "10",
      },
      {
        country: "Peru",
        countryShort: "PE",
        countryCode: "es",
        flagCode: "PE",
        currency: "PEN",
        currencySymbol: "S/.",
        taxName: "IGV",
        taxPercentage: "18",
      },
      {
        country: "Philippines",
        countryShort: "PH",
        countryCode: "en",
        flagCode: "PH",
        currency: "PHP",
        currencySymbol: "₱",
        taxName: "VAT",
        taxPercentage: "12",
      },
      {
        country: "Poland",
        countryShort: "PL",
        countryCode: "pl",
        flagCode: "PL",
        currency: "PLN",
        currencySymbol: "zł",
        taxName: "VAT",
        taxPercentage: "23",
      },
      {
        country: "Portugal",
        countryShort: "PT",
        countryCode: "pt",
        flagCode: "PT",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "23",
      },
      {
        country: "Qatar",
        countryShort: "QA",
        countryCode: "ar",
        flagCode: "QA",
        currency: "QAR",
        currencySymbol: "ر.ق",
        taxName: "VAT",
        taxPercentage: "5",
      },
      {
        country: "Romania",
        countryShort: "RO",
        countryCode: "ro",
        flagCode: "RO",
        currency: "RON",
        currencySymbol: "lei",
        taxName: "VAT",
        taxPercentage: "19",
      },
      {
        country: "Russia",
        countryShort: "RU",
        countryCode: "ru",
        flagCode: "RU",
        currency: "RUB",
        currencySymbol: "₽",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Rwanda",
        countryShort: "RW",
        countryCode: "rw",
        flagCode: "RW",
        currency: "RWF",
        currencySymbol: "FRw",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Saint Kitts and Nevis",
        countryShort: "KN",
        countryCode: "en",
        flagCode: "KN",
        currency: "XCD",
        currencySymbol: "$",
        taxName: "VAT",
        taxPercentage: "17",
      },
      {
        country: "Saint Lucia",
        countryShort: "LC",
        countryCode: "en",
        flagCode: "LC",
        currency: "XCD",
        currencySymbol: "$",
        taxName: "VAT",
        taxPercentage: "12.5",
      },
      {
        country: "Saint Vincent and the Grenadines",
        countryShort: "VC",
        countryCode: "en",
        flagCode: "VC",
        currency: "XCD",
        currencySymbol: "$",
        taxName: "VAT",
        taxPercentage: "16",
      },
      {
        country: "Samoa",
        countryShort: "WS",
        countryCode: "sm",
        flagCode: "WS",
        currency: "WST",
        currencySymbol: "T",
        taxName: "VAGST",
        taxPercentage: "15",
      },
      {
        country: "San Marino",
        countryShort: "SM",
        countryCode: "it",
        flagCode: "SM",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "Indirect Tax",
        taxPercentage: "0",
      },
      {
        country: "Sao Tome and Principe",
        countryShort: "ST",
        countryCode: "pt",
        flagCode: "ST",
        currency: "STN",
        currencySymbol: "Db",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Saudi Arabia",
        countryShort: "SA",
        countryCode: "ar",
        flagCode: "SA",
        currency: "SAR",
        currencySymbol: "﷼",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Senegal",
        countryShort: "SN",
        countryCode: "fr",
        flagCode: "SN",
        currency: "XOF",
        currencySymbol: "CFA",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Serbia",
        countryShort: "RS",
        countryCode: "sr",
        flagCode: "RS",
        currency: "RSD",
        currencySymbol: "дин.",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Seychelles",
        countryShort: "SC",
        countryCode: "fr",
        flagCode: "SC",
        currency: "SCR",
        currencySymbol: "₨",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Sierra Leone",
        countryShort: "SL",
        countryCode: "en",
        flagCode: "SL",
        currency: "SLL",
        currencySymbol: "Le",
        taxName: "GST",
        taxPercentage: "15",
      },
      {
        country: "Singapore",
        countryShort: "SG",
        countryCode: "en",
        flagCode: "SG",
        currency: "SGD",
        currencySymbol: "$",
        taxName: "GST",
        taxPercentage: "8",
      },
      {
        country: "Slovakia",
        countryShort: "SK",
        countryCode: "sk",
        flagCode: "SK",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "Slovenia",
        countryShort: "SI",
        countryCode: "sl",
        flagCode: "SI",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "22",
      },
      {
        country: "Solomon Islands",
        countryShort: "SB",
        countryCode: "en",
        flagCode: "SB",
        currency: "SBD",
        currencySymbol: "$",
        taxName: "Consumption Tax",
        taxPercentage: "15",
      },
      {
        country: "Somalia",
        countryShort: "SO",
        countryCode: "so",
        flagCode: "SO",
        currency: "SOS",
        currencySymbol: "Sh",
        taxName: "Sales Tax",
        taxPercentage: "5",
      },
      {
        country: "South Africa",
        countryShort: "ZA",
        countryCode: "en",
        flagCode: "ZA",
        currency: "ZAR",
        currencySymbol: "R",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "South Korea",
        countryShort: "KR",
        countryCode: "ko",
        flagCode: "KR",
        currency: "KRW",
        currencySymbol: "₩",
        taxName: "VAT",
        taxPercentage: "10",
      },
      {
        country: "South Sudan",
        countryShort: "SS",
        countryCode: "en",
        flagCode: "SS",
        currency: "SSP",
        currencySymbol: "£",
        taxName: "GST",
        taxPercentage: "18",
      },
      {
        country: "Spain",
        countryShort: "ES",
        countryCode: "es",
        flagCode: "ES",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "VAT",
        taxPercentage: "21",
      },
      {
        country: "Sri Lanka",
        countryShort: "LK",
        countryCode: "si",
        flagCode: "LK",
        currency: "LKR",
        currencySymbol: "₨",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Sudan",
        countryShort: "SD",
        countryCode: "ar",
        flagCode: "SD",
        currency: "SDG",
        currencySymbol: "ج.س.",
        taxName: "VAT",
        taxPercentage: "17",
      },
      {
        country: "Suriname",
        countryShort: "SR",
        countryCode: "nl",
        flagCode: "SR",
        currency: "SRD",
        currencySymbol: "$",
        taxName: "VAT",
        taxPercentage: "10",
      },
      {
        country: "Sweden",
        countryShort: "SE",
        countryCode: "sv",
        flagCode: "SE",
        currency: "SEK",
        currencySymbol: "kr",
        taxName: "VAT",
        taxPercentage: "25",
      },
      {
        country: "Switzerland",
        countryShort: "CH",
        countryCode: "de",
        flagCode: "CH",
        currency: "CHF",
        currencySymbol: "CHF",
        taxName: "VAT",
        taxPercentage: "7.7",
      },
      {
        country: "Syria",
        countryShort: "SY",
        countryCode: "ar",
        flagCode: "SY",
        currency: "SYP",
        currencySymbol: "£",
        taxName: "VAT",
        taxPercentage: "10",
      },
      {
        country: "Taiwan",
        countryShort: "TW",
        countryCode: "zh",
        flagCode: "TW",
        currency: "TWD",
        currencySymbol: "NT$",
        taxName: "VAT",
        taxPercentage: "5",
      },
      {
        country: "Tajikistan",
        countryShort: "TJ",
        countryCode: "tg",
        flagCode: "TJ",
        currency: "TJS",
        currencySymbol: "ЅМ",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Tanzania",
        countryShort: "TZ",
        countryCode: "sw",
        flagCode: "TZ",
        currency: "TZS",
        currencySymbol: "TSh",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Thailand",
        countryShort: "TH",
        countryCode: "th",
        flagCode: "TH",
        currency: "THB",
        currencySymbol: "฿",
        taxName: "VAT",
        taxPercentage: "7",
      },
      {
        country: "Timor-Leste",
        countryShort: "TL",
        countryCode: "pt",
        flagCode: "TL",
        currency: "USD",
        currencySymbol: "$",
        taxName: "Sales Tax",
        taxPercentage: "10",
      },
      {
        country: "Togo",
        countryShort: "TG",
        countryCode: "fr",
        flagCode: "TG",
        currency: "XOF",
        currencySymbol: "CFA",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Tonga",
        countryShort: "TO",
        countryCode: "to",
        flagCode: "TO",
        currency: "TOP",
        currencySymbol: "T$",
        taxName: "Consumption Tax",
        taxPercentage: "15",
      },
      {
        country: "Trinidad and Tobago",
        countryShort: "TT",
        countryCode: "en",
        flagCode: "TT",
        currency: "TTD",
        currencySymbol: "TT$",
        taxName: "VAT",
        taxPercentage: "12.5",
      },
      {
        country: "Tunisia",
        countryShort: "TN",
        countryCode: "ar",
        flagCode: "TN",
        currency: "TND",
        currencySymbol: "د.ت",
        taxName: "VAT",
        taxPercentage: "19",
      },
      {
        country: "Turkey",
        countryShort: "TR",
        countryCode: "tr",
        flagCode: "TR",
        currency: "TRY",
        currencySymbol: "₺",
        taxName: "KDV",
        taxPercentage: "18",
      },
      {
        country: "Turkmenistan",
        countryShort: "TM",
        countryCode: "tk",
        flagCode: "TM",
        currency: "TMT",
        currencySymbol: "m",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Tuvalu",
        countryShort: "TV",
        countryCode: "en",
        flagCode: "TV",
        currency: "AUD",
        currencySymbol: "$",
        taxName: "Consumption Tax",
        taxPercentage: "7",
      },
      {
        country: "Uganda",
        countryShort: "UG",
        countryCode: "en",
        flagCode: "UG",
        currency: "UGX",
        currencySymbol: "USh",
        taxName: "VAT",
        taxPercentage: "18",
      },
      {
        country: "Ukraine",
        countryShort: "UA",
        countryCode: "uk",
        flagCode: "UA",
        currency: "UAH",
        currencySymbol: "₴",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "United Arab Emirates",
        countryShort: "AE",
        countryCode: "ar",
        flagCode: "AE",
        currency: "AED",
        currencySymbol: "د.إ",
        taxName: "VAT",
        taxPercentage: "5",
      },
      {
        country: "United Kingdom",
        countryShort: "GB",
        countryCode: "en",
        flagCode: "GB",
        currency: "GBP",
        currencySymbol: "£",
        taxName: "VAT",
        taxPercentage: "20",
      },
      {
        country: "United States",
        countryShort: "US",
        countryCode: "en",
        flagCode: "US",
        currency: "USD",
        currencySymbol: "$",
        taxName: "Sales Tax",
        taxPercentage: "10",
      },
      {
        country: "Uruguay",
        countryShort: "UY",
        countryCode: "es",
        flagCode: "UY",
        currency: "UYU",
        currencySymbol: "$U",
        taxName: "VAT",
        taxPercentage: "22",
      },
      {
        country: "Uzbekistan",
        countryShort: "UZ",
        countryCode: "uz",
        flagCode: "UZ",
        currency: "UZS",
        currencySymbol: "лв",
        taxName: "VAT",
        taxPercentage: "12",
      },
      {
        country: "Vanuatu",
        countryShort: "VU",
        countryCode: "bi",
        flagCode: "VU",
        currency: "VUV",
        currencySymbol: "VT",
        taxName: "VAT",
        taxPercentage: "15",
      },
      {
        country: "Vatican City",
        countryShort: "VA",
        countryCode: "it",
        flagCode: "VA",
        currency: "EUR",
        currencySymbol: "€",
        taxName: "Exempt",
        taxPercentage: "0",
      },
      {
        country: "Venezuela",
        countryShort: "VE",
        countryCode: "es",
        flagCode: "VE",
        currency: "VES",
        currencySymbol: "Bs.S",
        taxName: "VAT",
        taxPercentage: "16",
      },
      {
        country: "Vietnam",
        countryShort: "VN",
        countryCode: "vi",
        flagCode: "VN",
        currency: "VND",
        currencySymbol: "₫",
        taxName: "VAT",
        taxPercentage: "10",
      },
      {
        country: "Yemen",
        countryShort: "YE",
        countryCode: "ar",
        flagCode: "YE",
        currency: "YER",
        currencySymbol: "﷼",
        taxName: "GST",
        taxPercentage: "5",
      },
      {
        country: "Zambia",
        countryShort: "ZM",
        countryCode: "en",
        flagCode: "ZM",
        currency: "ZMW",
        currencySymbol: "ZK",
        taxName: "VAT",
        taxPercentage: "16",
      },
      {
        country: "Zimbabwe",
        countryShort: "ZW",
        countryCode: "en",
        flagCode: "ZW",
        currency: "ZWL",
        currencySymbol: "$",
        taxName: "VAT",
        taxPercentage: "14.5",
      }
    ];
    
    export default countryData;